import React from "react";
import Loader from "../../../components/Loader";
import { Box, Grid, Stack, TablePagination, Typography } from "@mui/material";

import RequestAccordion from "./RequestAccordion";
import MainCard from "../../../components/MainCard";
import { useAppContext } from "../../../context/AppContext";

const AllRequestsReport = ({
  isLoading,
  totalCount,
  iterationId,
  statusFilter,
  sortOrder,
  searchQuery,
}) => {
  const { getAPITestCases } = useAppContext();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [totalRequests, setTotalRequests] = React.useState(totalCount || 0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  const [executions, setExecutions] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const data = await getAPITestCases(
        iterationId,
        page,
        rowsPerPage,
        searchQuery,
        statusFilter,
        sortOrder
      );
      if (!data) return;
      setExecutions(data.testCases);
      setTotalRequests(data.totalTestCases);
    };
    fetchData();
  }, [page, rowsPerPage, searchQuery, statusFilter, sortOrder]);

  return isLoading ? (
    <Loader />
  ) : !executions?.length ? (
    <Box py={5} textAlign="center">
      <Typography variant="body1" color="text.secondary">
        No requests available for this iteration.
      </Typography>
    </Box>
  ) : (
    <>
      <Stack spacing={2}>
        <Stack spacing={2}>
          {executions?.map((execution, index) => (
            <RequestAccordion execution={execution} index={index} />
          ))}
        </Stack>
        <Grid container justifyContent="right" sx={{ mt: 2 }}>
          <TablePagination
            rowsPerPageOptions={[20, 30, 50]}
            component={MainCard}
            content={false}
            count={totalRequests}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Stack>
    </>
  );
};

export default AllRequestsReport;
